// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"646":"02add0f2","1279":"7b99a812","1309":"4676898b","6674":"9a655a13","7441":"02add0f2","8793":"a51722d9"}[chunkId] + ".chunk.css";
};